import { useNotificationData } from '@/shared/hooks';

/**
 * Hook simplificado para consumir datos de notificaciones
 *
 * @remarks
 * - Solo consume datos del store a través de la facade
 * - No hace peticiones HTTP
 * - Ideal para componentes de UI como NavBar, Modal, etc.
 *
 * @deprecated Usar directamente useNotificationData de @/shared/hooks
 * Este hook será removido en favor del facade pattern
 */
export const useNotificationsData = () => {
  const {
    notifications,
    isLoaded,
    loading,
    error,
    hasNotifications,
    totalNotifications,
    toastsShown,
  } = useNotificationData();

  return {
    // Solo estado de lectura
    notifications,
    isLoaded,
    loading,
    error,
    hasNotifications,
    totalNotifications,
    toastsShown,
  };
};
